import { Bx, Typo } from '@curry-group/mui-curcuma';
import { Grid } from '@material-ui/core';
import React from 'react';
import { allowedMimeTypes } from '../../../helper/validator';
import { FormDropZone } from '../controls/dropzone';
import { FormInput } from '../controls/input';
import { FormRTE } from '../controls/rte';

interface IFormRequisition {
  formData: any;
  headline?: string;
  subtitle?: string;
  onChange: (value: any) => void;
}

export const FormRequisition: React.FC<IFormRequisition> = ({ formData, headline, subtitle, onChange }) => {
  return (
    <React.Fragment>
      {headline && (
        <Bx mb={1}>
          <Typo variant="h1" component="h1">
            {headline}
          </Typo>
        </Bx>
      )}
      {subtitle && <Typo variant="subtitle1">{subtitle}</Typo>}
      <Bx my={headline || subtitle ? 8 : 0}>
        <Grid container spacing={4}>
          <Grid item xs={12} lg={12}>
            <FormInput
              value={formData?.itemData?.title}
              label={'Titel'}
              placeholder={'Titel eingeben'}
              minLength={5}
              maxLength={120}
              onChange={val => {
                onChange({ ...formData, itemData: { ...formData?.itemData, title: val } });
              }}
              lazy
            />
          </Grid>
          <Grid item xs={12} lg={12}>
            <FormRTE
              value={formData?.itemData?.contentRequisitionContext}
              label={'Einordnung in das Versorgungsumfeld'}
              placeholder={'Bitte ordnen Sie Ihren Bedarf ein...'}
              mandatory={true}
              minLength={100}
              maxLength={2500}
              onChange={val => {
                onChange({ ...formData, itemData: { ...formData?.itemData, contentRequisitionContext: val } });
              }}
              lazy
            />
          </Grid>
          <Grid item xs={12} lg={12}>
            <FormRTE
              value={formData?.itemData?.content}
              label={'Versorgungsbedarf'}
              placeholder={'Bitte beschreiben Sie Ihren Bedarf...'}
              mandatory={true}
              minLength={100}
              maxLength={2500}
              onChange={val => {
                onChange({ ...formData, itemData: { ...formData?.itemData, content: val } });
              }}
              lazy
            />
          </Grid>
          <Grid item xs={12} lg={12}>
            <FormRTE
              value={formData?.itemData?.contentRequisitionSolutions}
              label={'Ideen für Lösungen'}
              placeholder={'Bitte beschreiben Sie Ihren Lösungsansatz...'}
              mandatory={true}
              minLength={100}
              maxLength={2500}
              onChange={val => {
                onChange({ ...formData, itemData: { ...formData?.itemData, contentRequisitionSolutions: val } });
              }}
              lazy
            />
          </Grid>
          <Grid item xs={12} lg={12}>
            <FormDropZone
              value={formData?.attachments ? formData.attachments : []}
              label={'Anhänge'}
              placeholder={'Hochladen oder Datei(en) hier ablegen'}
              mandatory={false}
              accept={allowedMimeTypes}
              onChange={val => {
                onChange({ ...formData, attachments: val });
              }}
              multiple
            />
          </Grid>
        </Grid>
      </Bx>
    </React.Fragment>
  );
};
